import Vue from 'vue';

import campaignBlockSubAccountsUrls from '../../../urls/campaignBlockSubAccountsUrls';

const state = {

  blockedSubAccounts: [],

  subAccountsDetails: {
    hasSubAccounts: false,
    blockedSubAccountsCount: 0,
    maxSubAccountLength: 0,
    maxAllowed: 2000
  }

};

const getters = {

  blockedSubAccounts(state) {
    return state.blockedSubAccounts;
  },

  subAccountsDetails(state) {
    return state.subAccountsDetails;
  }

};

const mutations = {

  setSubAccountsDetails(state, data) {
    state.subAccountsDetails.hasSubAccounts = data.hasSubAccounts;
    state.subAccountsDetails.blockedSubAccountsCount = data.blockedSubAccountsCount;
    state.subAccountsDetails.maxSubAccountLength = data.maxSubAccountLength;
    state.subAccountsDetails.maxAllowed = data.maxAllowed;
  },

  removeSubAccount(state, subAccount) {
    let index = state.blockedSubAccounts.findIndex((c) => {
      return c == subAccount;
    });
    state.blockedSubAccounts.splice(index, 1);
  },

  removeAllSubAccounts(state) {
    state.blockedSubAccounts = [];
  }

};

const actions = {

  fetchSubAccountsDetails(context, payload) {
    return new Promise((resolve, reject) => {

      Vue.$http.post(campaignBlockSubAccountsUrls.getSubAccountsDetails, payload).then((response) => {

        context.commit('setSubAccountsDetails', response.data);
        resolve(response.data);

      }).catch((error) => {

        reject();

      });

    });
  },

  fetchBlockedSubAccounts(context, payload) {
    return new Promise((resolve, reject) => {

      Vue.$http.post(campaignBlockSubAccountsUrls.getBlockedSubAccounts, payload).then((response) => {

        context.state.blockedSubAccounts = response.data.blockedSubAccounts;
        resolve(response.data);

      }).catch((error) => {

        reject();

      });

    });
  },

  blockSubAccounts(context, payload) {
    return new Promise((resolve, reject) => {

      Vue.$http.post(campaignBlockSubAccountsUrls.blockSubAccounts, payload).then((response) => {

        if (!response.data.error) {
          context.state.subAccountsDetails.blockedSubAccountsCount = response.data.blockedSubAccountsCount;
        }
        resolve(response.data);

      }).catch((error) => {

        reject();

      });

    });
  },

  unblockSubAccounts(context, payload) {

    return new Promise((resolve, reject) => {

      Vue.$http.post(campaignBlockSubAccountsUrls.unblockSubAccounts, payload).then((response) => {

        if (!response.data.error) {
          context.state.subAccountsDetails.blockedSubAccountsCount = response.data.blockedSubAccountsCount;
        }
        resolve(response.data);

      }).catch((error) => {

        reject();

      });
    });
  }

};

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/ReportByApp/store/campaignBlockSubAccounts.js